import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import type { AnalyticsFuelType } from '../../services/api';

interface FuelTypesTabProps {
  data?: AnalyticsFuelType[];
}

const FuelTypesTab: React.FC<FuelTypesTabProps> = ({ data }) => {
  // Map colors to fuel types consistently with the main dashboard
  const getColor = (type?: string) => {
    if (!type) return '#8b5cf6';
    const lower = type.toLowerCase();
    if (lower.includes('petrol')) return '#ff6b35';
    if (lower.includes('diesel')) return '#3b82f6';
    return '#8b5cf6'; // fallback
  };

  const chartData = data && data.length > 0
    ? data
        .filter(item => !item.fuelType?.toLowerCase().includes('gas'))
        .map(item => ({
          name: item.fuelType || 'Unknown',
          value: item.percentage || 0,
          color: getColor(item.fuelType)
        }))
    : [];

  if (chartData.length === 0) {
    return (
      <div className="tab-content">
        <div className="no-data-message">
          <p>No fuel distribution data available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div className="fuel-types-container">
        <div className="chart-container">
          <h3 className="chart-title">Fuel Type Distribution (%)</h3>
          <div className="pie-chart-wrapper">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={100}
                  paddingAngle={5}
                  dataKey="value"
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value: number) => `${value}%`}
                  contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                />
                <Legend
                  verticalAlign="bottom"
                  height={36}
                  formatter={(value: string, entry: any) => (
                    <span style={{ color: (entry as any).color, fontWeight: 600, fontSize: '13px' }}>
                      {value}
                    </span>
                  )}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="fuel-distribution-list">
          {chartData.map((fuel) => (
            <div key={fuel.name} className="fuel-item">
              <div className="fuel-indicator">
                <div
                  className="fuel-color"
                  style={{ backgroundColor: fuel.color }}
                ></div>
                <span className="fuel-name">{fuel.name}</span>
              </div>
              <span className="fuel-percentage">{fuel.value}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FuelTypesTab;
